import Vue from 'vue'

const actions = {
  loadProducts ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/products.json').then((response) => {
        commit('SET_PRODUCTS', { products: response.data })

        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default actions
